import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactInfo } from '../data/mock';

const WhatsAppWidget = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-6 left-6 z-40" data-testid="whatsapp-widget">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-16 left-0 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-grey/20 dark:border-gray-700 p-3 w-48 animate-fade-in-up">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-5 h-5 bg-grey/20 dark:bg-gray-600 rounded-full flex items-center justify-center"
          >
            <X size={10} className="text-dark-grey dark:text-gray-300" />
          </button>
          <p className="text-xs text-dark-grey dark:text-gray-300 mb-2">Schreiben Sie uns!</p>
          <a
            href={`https://wa.me/${contactInfo.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center text-xs bg-[#25D366] text-white px-3 py-2 rounded-lg hover:bg-[#20bd5a] transition-colors"
          >
            Chat starten
          </a>
        </div>
      )}

      {/* Button */}
      <button
        onClick={() => setShowTooltip(!showTooltip)}
        className="w-12 h-12 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl"
        aria-label="WhatsApp Chat"
        data-testid="whatsapp-btn"
      >
        <MessageCircle size={22} />
      </button>
    </div>
  );
};

export default WhatsAppWidget;
